import { render, staticRenderFns } from "./HistoryMain.vue?vue&type=template&id=3456b056&"
import script from "./HistoryMain.vue?vue&type=script&lang=js&"
export * from "./HistoryMain.vue?vue&type=script&lang=js&"
import style0 from "./HistoryMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports